import Component from "@glimmer/component";
import { fn } from "@ember/helper";
import { action } from "@ember/object";
import { inject as service } from "@ember/service";
import { and, not, or } from "truth-helpers";
import DButton from "discourse/components/d-button";
import DropdownMenu from "discourse/components/dropdown-menu";
import concatClass from "discourse/helpers/concat-class";
import icon from "discourse-common/helpers/d-icon";
import getURL from "discourse-common/lib/get-url";
import DMenu from "float-kit/components/d-menu";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
export default class TopicAdminMenu extends Component {
  static #_ = (() => dt7948.g(this.prototype, "adminTopicMenuButtons", [service]))();
  #adminTopicMenuButtons = (() => (dt7948.i(this, "adminTopicMenuButtons"), void 0))();
  static #_2 = (() => dt7948.g(this.prototype, "currentUser", [service]))();
  #currentUser = (() => (dt7948.i(this, "currentUser"), void 0))();
  onRegisterApi(api1) {
    this.dMenu = api1;
  }
  static #_3 = (() => dt7948.n(this.prototype, "onRegisterApi", [action]))();
  async onButtonAction(buttonAction1) {
    await this.dMenu.close();
    this.args[buttonAction1]?.();
  }
  static #_4 = (() => dt7948.n(this.prototype, "onButtonAction", [action]))();
  async onExtraButtonAction(buttonAction1) {
    await this.dMenu.close();
    buttonAction1?.();
  }
  static #_5 = (() => dt7948.n(this.prototype, "onExtraButtonAction", [action]))();
  get extraButtons() {
    return this.adminTopicMenuButtons.callbacks.map(callback1 => {
      return callback1(this.args.topic);
    }).filter(Boolean);
  }
  get details() {
    return this.args.topic.get("details");
  }
  get isPrivateMessage() {
    return this.args.topic.get("isPrivateMessage");
  }
  get featured() {
    return !!this.args.topic.get("pinned_at") || this.args.topic.get("isBanner");
  }
  get visible() {
    return this.args.topic.get("visible");
  }
  get canDelete() {
    return this.details.get("can_delete");
  }
  get canRecover() {
    return this.details.get("can_recover");
  }
  get archived() {
    return this.args.topic.get("archived");
  }
  get topicModerationHistoryUrl() {
    return getURL(`/review?topic_id=${this.args.topic.id}&status=all`);
  }
  get showAdminButton() {
    return this.currentUser?.canManageTopic || this.details?.can_archive_topic || this.details?.can_close_topic;
  }
  static #_6 = (() => setComponentTemplate(createTemplateFactory(
  /*
    
      {{#if this.showAdminButton}}
        <span class="topic-admin-menu-button-container">
          <span class="topic-admin-menu-button">
            <DMenu
              @identifier="topic-admin-menu"
              @onRegisterApi={{this.onRegisterApi}}
              @modalForMobile={{true}}
              @autofocus={{true}}
              @triggerClass="btn-default btn-icon toggle-admin-menu"
            >
              <:trigger>
                {{icon "wrench"}}
              </:trigger>
              <:content>
                <DropdownMenu as |dropdown|>
                  {{#if
                    (or
                      this.currentUser.canManageTopic
                      this.details.can_split_merge_topic
                    )
                  }}
                    <dropdown.item class="topic-admin-multi-select">
                      <DButton
                        class="btn-transparent"
                        @label="topic.actions.multi_select"
                        @action={{fn this.onButtonAction "toggleMultiSelect"}}
                        @icon="tasks"
                      />
                    </dropdown.item>
                  {{/if}}
  
                  {{#if
                    (or
                      this.currentUser.canManageTopic
                      this.details.can_moderate_category
                    )
                  }}
                    {{#if this.canDelete}}
                      <dropdown.item class="topic-admin-delete">
                        <DButton
                          @label="topic.actions.delete"
                          @action={{fn this.onButtonAction "deleteTopic"}}
                          @icon="far-trash-alt"
                          class="popup-menu-btn-danger btn-danger btn-transparent"
                        />
                      </dropdown.item>
                    {{else if this.canRecover}}
                      <dropdown.item class="topic-admin-recover">
                        <DButton
                          class="btn-transparent"
                          @label="topic.actions.recover"
                          @action={{fn this.onButtonAction "recoverTopic"}}
                          @icon="undo"
                        />
                      </dropdown.item>
                    {{/if}}
                  {{/if}}
  
                  {{#if this.details.can_close_topic}}
                    <dropdown.item
                      class={{if
                        @topic.closed
                        "topic-admin-open"
                        "topic-admin-close"
                      }}
                    >
                      <DButton
                        class="btn-transparent"
                        @label={{if
                          @topic.closed
                          "topic.actions.open"
                          "topic.actions.close"
                        }}
                        @action={{fn this.onButtonAction "toggleClosed"}}
                        @icon={{if @topic.closed "unlock" "lock"}}
                      />
                    </dropdown.item>
                  {{/if}}
  
                  {{#if
                    (and
                      this.details.can_pin_unpin_topic
                      (not this.isPrivateMessage)
                      (or this.visible this.featured)
                    )
                  }}
                    <dropdown.item class="topic-admin-pin">
                      <DButton
                        class="btn-transparent"
                        @label={{if
                          this.featured
                          "topic.actions.unpin"
                          "topic.actions.pin"
                        }}
                        @action={{fn this.onButtonAction "showFeatureTopic"}}
                        @icon="thumbtack"
                      />
                    </dropdown.item>
                  {{/if}}
  
                  {{#if
                    (and
                      this.details.can_archive_topic (not this.isPrivateMessage)
                    )
                  }}
                    <dropdown.item class="topic-admin-archive">
                      <DButton
                        class="btn-transparent"
                        @label={{if
                          this.archived
                          "topic.actions.unarchive"
                          "topic.actions.archive"
                        }}
                        @action={{fn this.onButtonAction "toggleArchived"}}
                        @icon="folder"
                      />
                    </dropdown.item>
                  {{/if}}
  
                  {{#if this.details.can_toggle_topic_visibility}}
                    <dropdown.item class="topic-admin-visible">
                      <DButton
                        class="btn-transparent"
                        @label={{if
                          this.visible
                          "topic.actions.invisible"
                          "topic.actions.visible"
                        }}
                        @action={{fn this.onButtonAction "toggleVisibility"}}
                        @icon={{if this.visible "far-eye-slash" "far-eye"}}
                      />
                    </dropdown.item>
                  {{/if}}
  
                  {{#if (and this.details.can_convert_topic)}}
                    <dropdown.item class="topic-admin-convert">
                      <DButton
                        class="btn-transparent"
                        @label={{if
                          this.isPrivateMessage
                          "topic.actions.make_public"
                          "topic.actions.make_private"
                        }}
                        @action={{fn
                          this.onButtonAction
                          (if
                            this.isPrivateMessage
                            "convertToPublicTopic"
                            "convertToPrivateMessage"
                          )
                        }}
                        @icon={{if this.isPrivateMessage "comment" "envelope"}}
                      />
                    </dropdown.item>
                  {{/if}}
  
                  <dropdown.divider />
  
                  {{#if this.currentUser.canManageTopic}}
                    <dropdown.item class="admin-topic-timer-update">
                      <DButton
                        class="btn-transparent"
                        @label="topic.actions.timed_update"
                        @action={{fn this.onButtonAction "showTopicTimerModal"}}
                        @icon="far-clock"
                      />
                    </dropdown.item>
  
                    {{#if this.currentUser.staff}}
                      <dropdown.item class="topic-admin-change-timestamp">
                        <DButton
                          class="btn-transparent"
                          @label="topic.change_timestamp.title"
                          @action={{fn this.onButtonAction "showChangeTimestamp"}}
                          @icon="calendar-alt"
                        />
                      </dropdown.item>
                    {{/if}}
  
                    <dropdown.item class="topic-admin-reset-bump-date">
                      <DButton
                        class="btn-transparent"
                        @label="topic.actions.reset_bump_date"
                        @action={{fn this.onButtonAction "resetBumpDate"}}
                        @icon="anchor"
                      />
                    </dropdown.item>
  
                    <dropdown.item class="topic-admin-slow-mode">
                      <DButton
                        class="btn-transparent"
                        @label="topic.actions.slow_mode"
                        @action={{fn
                          this.onButtonAction
                          "showTopicSlowModeUpdate"
                        }}
                        @icon="hourglass-start"
                      />
                    </dropdown.item>
                  {{/if}}
  
                  {{#if (or this.currentUser.staff this.extraButtons.length)}}
                    <dropdown.divider />
  
                    {{#if this.currentUser.staff}}
                      <dropdown.item class="topic-admin-moderation-history">
                        <DButton
                          class="btn-transparent"
                          @label="review.moderation_history"
                          @href={{this.topicModerationHistoryUrl}}
                          @icon="list"
                        />
                      </dropdown.item>
                    {{/if}}
  
                    {{#each this.extraButtons as |button|}}
                      <dropdown.item>
                        <DButton
                          @label={{button.label}}
                          @translatedLabel={{button.translatedLabel}}
                          @icon={{button.icon}}
                          class={{concatClass "btn-transparent" button.className}}
                          @action={{fn this.onExtraButtonAction button.action}}
                        />
                      </dropdown.item>
                    {{/each}}
                  {{/if}}
                </DropdownMenu>
              </:content>
            </DMenu>
          </span>
        </span>
      {{/if}}
    
  */
  {
    "id": "vUPOZ4br",
    "block": "[[[1,\"\\n\"],[41,[30,0,[\"showAdminButton\"]],[[[1,\"      \"],[10,1],[14,0,\"topic-admin-menu-button-container\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"topic-admin-menu-button\"],[12],[1,\"\\n          \"],[8,[32,0],null,[[\"@identifier\",\"@onRegisterApi\",\"@modalForMobile\",\"@autofocus\",\"@triggerClass\"],[\"topic-admin-menu\",[30,0,[\"onRegisterApi\"]],true,true,\"btn-default btn-icon toggle-admin-menu\"]],[[\"trigger\",\"content\"],[[[[1,\"\\n              \"],[1,[28,[32,1],[\"wrench\"],null]],[1,\"\\n            \"]],[]],[[[1,\"\\n              \"],[8,[32,2],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[28,[32,3],[[30,0,[\"currentUser\",\"canManageTopic\"]],[30,0,[\"details\",\"can_split_merge_topic\"]]],null],[[[1,\"                  \"],[8,[30,1,[\"item\"]],[[24,0,\"topic-admin-multi-select\"]],null,[[\"default\"],[[[[1,\"\\n                    \"],[8,[32,4],[[24,0,\"btn-transparent\"]],[[\"@label\",\"@action\",\"@icon\"],[\"topic.actions.multi_select\",[28,[32,5],[[30,0,[\"onButtonAction\"]],\"toggleMultiSelect\"],null],\"tasks\"]],null],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[32,3],[[30,0,[\"currentUser\",\"canManageTopic\"]],[30,0,[\"details\",\"can_moderate_category\"]]],null],[[[41,[30,0,[\"canDelete\"]],[[[1,\"                    \"],[8,[30,1,[\"item\"]],[[24,0,\"topic-admin-delete\"]],null,[[\"default\"],[[[[1,\"\\n                      \"],[8,[32,4],[[24,0,\"popup-menu-btn-danger btn-danger btn-transparent\"]],[[\"@label\",\"@action\",\"@icon\"],[\"topic.actions.delete\",[28,[32,5],[[30,0,[\"onButtonAction\"]],\"deleteTopic\"],null],\"far-trash-alt\"]],null],[1,\"\\n                    \"]],[]]]]],[1,\"\\n\"]],[]],[[[41,[30,0,[\"canRecover\"]],[[[1,\"                    \"],[8,[30,1,[\"item\"]],[[24,0,\"topic-admin-recover\"]],null,[[\"default\"],[[[[1,\"\\n                      \"],[8,[32,4],[[24,0,\"btn-transparent\"]],[[\"@label\",\"@action\",\"@icon\"],[\"topic.actions.recover\",[28,[32,5],[[30,0,[\"onButtonAction\"]],\"recoverTopic\"],null],\"undo\"]],null],[1,\"\\n                    \"]],[]]]]],[1,\"\\n                  \"]],[]],null]],[]]]],[]],null],[1,\"\\n\"],[41,[30,0,[\"details\",\"can_close_topic\"]],[[[1,\"                  \"],[8,[30,1,[\"item\"]],[[16,0,[52,[30,2,[\"closed\"]],\"topic-admin-open\",\"topic-admin-close\"]]],null,[[\"default\"],[[[[1,\"\\n                    \"],[8,[32,4],[[24,0,\"btn-transparent\"]],[[\"@label\",\"@action\",\"@icon\"],[[52,[30,2,[\"closed\"]],\"topic.actions.open\",\"topic.actions.close\"],[28,[32,5],[[30,0,[\"onButtonAction\"]],\"toggleClosed\"],null],[52,[30,2,[\"closed\"]],\"unlock\",\"lock\"]]],null],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[32,6],[[30,0,[\"details\",\"can_pin_unpin_topic\"]],[28,[32,7],[[30,0,[\"isPrivateMessage\"]]],null],[28,[32,3],[[30,0,[\"visible\"]],[30,0,[\"featured\"]]],null]],null],[[[1,\"                  \"],[8,[30,1,[\"item\"]],[[24,0,\"topic-admin-pin\"]],null,[[\"default\"],[[[[1,\"\\n                    \"],[8,[32,4],[[24,0,\"btn-transparent\"]],[[\"@label\",\"@action\",\"@icon\"],[[52,[30,0,[\"featured\"]],\"topic.actions.unpin\",\"topic.actions.pin\"],[28,[32,5],[[30,0,[\"onButtonAction\"]],\"showFeatureTopic\"],null],\"thumbtack\"]],null],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[32,6],[[30,0,[\"details\",\"can_archive_topic\"]],[28,[32,7],[[30,0,[\"isPrivateMessage\"]]],null]],null],[[[1,\"                  \"],[8,[30,1,[\"item\"]],[[24,0,\"topic-admin-archive\"]],null,[[\"default\"],[[[[1,\"\\n                    \"],[8,[32,4],[[24,0,\"btn-transparent\"]],[[\"@label\",\"@action\",\"@icon\"],[[52,[30,0,[\"archived\"]],\"topic.actions.unarchive\",\"topic.actions.archive\"],[28,[32,5],[[30,0,[\"onButtonAction\"]],\"toggleArchived\"],null],\"folder\"]],null],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"details\",\"can_toggle_topic_visibility\"]],[[[1,\"                  \"],[8,[30,1,[\"item\"]],[[24,0,\"topic-admin-visible\"]],null,[[\"default\"],[[[[1,\"\\n                    \"],[8,[32,4],[[24,0,\"btn-transparent\"]],[[\"@label\",\"@action\",\"@icon\"],[[52,[30,0,[\"visible\"]],\"topic.actions.invisible\",\"topic.actions.visible\"],[28,[32,5],[[30,0,[\"onButtonAction\"]],\"toggleVisibility\"],null],[52,[30,0,[\"visible\"]],\"far-eye-slash\",\"far-eye\"]]],null],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[32,6],[[30,0,[\"details\",\"can_convert_topic\"]]],null],[[[1,\"                  \"],[8,[30,1,[\"item\"]],[[24,0,\"topic-admin-convert\"]],null,[[\"default\"],[[[[1,\"\\n                    \"],[8,[32,4],[[24,0,\"btn-transparent\"]],[[\"@label\",\"@action\",\"@icon\"],[[52,[30,0,[\"isPrivateMessage\"]],\"topic.actions.make_public\",\"topic.actions.make_private\"],[28,[32,5],[[30,0,[\"onButtonAction\"]],[52,[30,0,[\"isPrivateMessage\"]],\"convertToPublicTopic\",\"convertToPrivateMessage\"]],null],[52,[30,0,[\"isPrivateMessage\"]],\"comment\",\"envelope\"]]],null],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n                \"],[8,[30,1,[\"divider\"]],null,null,null],[1,\"\\n\\n\"],[41,[30,0,[\"currentUser\",\"canManageTopic\"]],[[[1,\"                  \"],[8,[30,1,[\"item\"]],[[24,0,\"admin-topic-timer-update\"]],null,[[\"default\"],[[[[1,\"\\n                    \"],[8,[32,4],[[24,0,\"btn-transparent\"]],[[\"@label\",\"@action\",\"@icon\"],[\"topic.actions.timed_update\",[28,[32,5],[[30,0,[\"onButtonAction\"]],\"showTopicTimerModal\"],null],\"far-clock\"]],null],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"currentUser\",\"staff\"]],[[[1,\"                    \"],[8,[30,1,[\"item\"]],[[24,0,\"topic-admin-change-timestamp\"]],null,[[\"default\"],[[[[1,\"\\n                      \"],[8,[32,4],[[24,0,\"btn-transparent\"]],[[\"@label\",\"@action\",\"@icon\"],[\"topic.change_timestamp.title\",[28,[32,5],[[30,0,[\"onButtonAction\"]],\"showChangeTimestamp\"],null],\"calendar-alt\"]],null],[1,\"\\n                    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n                  \"],[8,[30,1,[\"item\"]],[[24,0,\"topic-admin-reset-bump-date\"]],null,[[\"default\"],[[[[1,\"\\n                    \"],[8,[32,4],[[24,0,\"btn-transparent\"]],[[\"@label\",\"@action\",\"@icon\"],[\"topic.actions.reset_bump_date\",[28,[32,5],[[30,0,[\"onButtonAction\"]],\"resetBumpDate\"],null],\"anchor\"]],null],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\\n                  \"],[8,[30,1,[\"item\"]],[[24,0,\"topic-admin-slow-mode\"]],null,[[\"default\"],[[[[1,\"\\n                    \"],[8,[32,4],[[24,0,\"btn-transparent\"]],[[\"@label\",\"@action\",\"@icon\"],[\"topic.actions.slow_mode\",[28,[32,5],[[30,0,[\"onButtonAction\"]],\"showTopicSlowModeUpdate\"],null],\"hourglass-start\"]],null],[1,\"\\n                  \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[32,3],[[30,0,[\"currentUser\",\"staff\"]],[30,0,[\"extraButtons\",\"length\"]]],null],[[[1,\"                  \"],[8,[30,1,[\"divider\"]],null,null,null],[1,\"\\n\\n\"],[41,[30,0,[\"currentUser\",\"staff\"]],[[[1,\"                    \"],[8,[30,1,[\"item\"]],[[24,0,\"topic-admin-moderation-history\"]],null,[[\"default\"],[[[[1,\"\\n                      \"],[8,[32,4],[[24,0,\"btn-transparent\"]],[[\"@label\",\"@href\",\"@icon\"],[\"review.moderation_history\",[30,0,[\"topicModerationHistoryUrl\"]],\"list\"]],null],[1,\"\\n                    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[42,[28,[31,2],[[28,[31,2],[[30,0,[\"extraButtons\"]]],null]],null],null,[[[1,\"                    \"],[8,[30,1,[\"item\"]],null,null,[[\"default\"],[[[[1,\"\\n                      \"],[8,[32,4],[[16,0,[28,[32,8],[\"btn-transparent\",[30,3,[\"className\"]]],null]]],[[\"@label\",\"@translatedLabel\",\"@icon\",\"@action\"],[[30,3,[\"label\"]],[30,3,[\"translatedLabel\"]],[30,3,[\"icon\"]],[28,[32,5],[[30,0,[\"onExtraButtonAction\"]],[30,3,[\"action\"]]],null]]],null],[1,\"\\n                    \"]],[]]]]],[1,\"\\n\"]],[3]],null]],[]],null],[1,\"              \"]],[1]]]]],[1,\"\\n            \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"]],[\"dropdown\",\"@topic\",\"button\"],false,[\"if\",\"each\",\"-track-array\"]]",
    "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/topic-admin-menu.js",
    "scope": () => [DMenu, icon, DropdownMenu, or, DButton, fn, and, not, concatClass],
    "isStrictMode": true
  }), this))();
}